import React, { useState } from 'react';
import ChartRenderer from './ChartRenderer';
import { ChartType } from './ChartType';
import InputRadio from '../../lib/inputs/InputRadio';
import ChartMetadataWidget from './ChartMetadataWidget';

interface StorageSummaryChartProps {
    parentId: string | undefined;
    chartType: string | null | undefined;
}

type SummaryFilter = 'By Volume' | 'By Type' | 'By Year';

const StorageSummaryChart: React.FC<StorageSummaryChartProps> = ({ parentId, chartType }) => {
    const [selectedFilter, setSelectedFilter] = useState<SummaryFilter>('By Volume');
    const [metadata, setMetadata] = useState<Record<string, any> | undefined>(undefined);

    const getEndpoint = (filter: SummaryFilter): string => {
        switch (filter) {
            case 'By Volume':
                return 'api/storageSummary/chartDataByVolume';
            case 'By Type':
                return 'api/storageSummary/chartDataByType';
            case 'By Year':
                return 'api/storageSummary/chartDataByYear';
            default:
                return 'api/storageSummary/chartDataByVolume';
        }
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFilter(e.target.value as SummaryFilter);
        setMetadata(undefined); // Clear metadata when filter changes
    };

    const handleMetadataLoaded = (loadedMetadata: Record<string, any>) => {
        setMetadata(loadedMetadata);
    };

    return (
        <div className="storage-summary-chart__wrapper">
            <div className="storage-summary-chart__filters">
                <div className="storage-summary-chart__filters-group">
                    <InputRadio
                        id="filterByVolume"
                        name="summaryFilter"
                        value="By Volume"
                        label="By Volume"
                        checked={selectedFilter === 'By Volume'}
                        onChangeCheckBox={handleFilterChange}
                    />
                    <InputRadio
                        id="filterByType"
                        name="summaryFilter"
                        value="By Type"
                        label="By Material Type"
                        checked={selectedFilter === 'By Type'}
                        onChangeCheckBox={handleFilterChange}
                    />
                    <InputRadio
                        id="filterByYear"
                        name="summaryFilter"
                        value="By Year"
                        label="By Year"
                        checked={selectedFilter === 'By Year'}
                        onChangeCheckBox={handleFilterChange}
                    />
                </div>
                {metadata && (
                    <div className="storage-summary-chart__metadata">
                        <ChartMetadataWidget metadata={metadata} />
                    </div>
                )}
            </div>
            <div className='storage-summary-chart__chart'>
                <ChartRenderer
                    chartType={chartType}
                    parentId={parentId}
                    endpoint={getEndpoint(selectedFilter)}
                    key={selectedFilter}
                    onMetadataLoaded={handleMetadataLoaded}
                />
            </div>
        </div>
    );
};

export default StorageSummaryChart;
